import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import QuoteQuickViewProducts from "./QuoteQuickViewProducts";

export default function QuoteQuickView({
  updateSearchParams,
  setShowQuickView,
  allData,
}) {
  /*   All States
   ********************************************* */
  const user = useSelector((state) => state.user.userInfo);
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const [selected, setSelected] = useState(null);

  /*   All Functions
   ********************************************* */

  const previousQuote = () => {
    if (allData && selected) {
      let currentIndex = allData.findIndex(
        (item) => item.quoteId === selected.quoteId
      );
      if (currentIndex > 0) {
        let previousItem = allData[currentIndex - 1];
        updateSearchParams("selected-quote", previousItem.quoteId);
      }
    }
  };

  const nextQuote = () => {
    if (allData && selected) {
      let currentIndex = allData.findIndex(
        (item) => item.quoteId === selected.quoteId
      );
      if (currentIndex < allData.length - 1) {
        let nextItem = allData[currentIndex + 1];
        updateSearchParams("selected-quote", nextItem.quoteId);
      }
    }
  };

  const handleViewCustomer = () => {
    navigate(`/customer/details/${selected?.customer?.customerId}`);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let timeout = setTimeout(() => {
      let currentSelected = searchParams.get("selected-quote");
      if (currentSelected && allData) {
        let _selected = allData.find(
          (item) => item.quoteId === parseInt(currentSelected)
        );
        setSelected(_selected);
      }
      if (!currentSelected) {
        setSelected(null);
      }
    }, 50);

    return () => clearTimeout(timeout);
  }, [searchParams, allData]);
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <h4>
            Q-{selected?.quoteId}
            {" - "}
            {selected?.jobName
              ? selected?.jobName?.length > 30
                ? selected?.jobName?.substring(0, 30) + "..."
                : selected?.jobName
              : "N/A"}
          </h4>
          <h4 className="d-flex">
            {(user?.permissions?.includes("customer_add") ||
              user?.permissions?.includes("customer_update") ||
              user?.permissions?.includes("customer_delete") ||
              user?.roles === "admin") && (
              <button
                onClick={handleViewCustomer}
                className="btn btn-sm btn-info me-2 py-0 px-1 mb-1 "
              >
                View Customer
              </button>
            )}
            <div className="">
              C-{selected?.customer?.customerId} -{" "}
              {selected?.customer?.customerName?.length <= 35
                ? selected?.customer?.customerName
                : `${selected?.customer?.customerName?.slice(0, 35)}..`}
            </div>
          </h4>
        </div>
        <div className="d-flex justify-content-end align-items-center gap-1">
          <button
            onClick={(e) => {
              e.stopPropagation();
              previousQuote();
            }}
            disabled={
              !allData ||
              !selected ||
              allData.length === 0 ||
              allData[0].quoteId === selected.quoteId
            }
            className={"btn btn-success btn-sm p-0 px-1 "}
          >
            <i className="mdi mdi-arrow-left-bold fs-3 py-0 my-0"></i>
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              nextQuote();
            }}
            disabled={
              !allData ||
              !selected ||
              allData.length === 0 ||
              allData[allData.length - 1].quoteId === selected.quoteId
            }
            className={"btn btn-success btn-sm p-0  px-1"}
          >
            <i className="mdi mdi-arrow-right-bold fs-3 py-0 my-0"></i>
          </button>
          <button
            className="btn btn-secondary"
            onClick={async () => {
              setShowQuickView(false);
              await updateSearchParams("selected-quote", null);
            }}
          >
            Close
          </button>
        </div>
      </div>
      <hr className="mt-0" />
      <div className="row">
        <div className="col-md-6  ">
          <div className="bg-white px-2 custom-border-radius-sm py-1">
            {/* General Details */}
            <h4 className="mb-1">General Details</h4>
            <hr className="mt-0" />

            {/* Contact Name */}
            <div className="row">
              <div className="col-md-4">Contact Name</div>
              <div className="col-md-8">
                {`
                ${selected?.contactFirstName || "-"} ${
                  selected?.contactLastName || "-"
                }
                  `}
              </div>
            </div>

            {/* Email */}
            <div className="row">
              <div className="col-md-4">Email</div>
              <div className="col-md-8">{selected?.contactEmail || "-"}</div>
            </div>

            {/* Phone */}
            <div className="row">
              <div className="col-md-4">Phone</div>
              <div className="col-md-8">{selected?.contactPhone || "-"}</div>
            </div>

            {/* Department */}
            <div className="row">
              <div className="col-md-4">Department</div>
              <div className="col-md-8">
                {selected?.contactDepartment || "-"}
              </div>
            </div>

            {/* Type */}
            <div className="row">
              <div className="col-md-4">Type</div>
              <div className="col-md-8">
                {selected?.bidId ? "Bid" : "Quote"}
              </div>
            </div>

            {/* Status */}
            <div className="row">
              <div className="col-md-4">Status</div>
              <div className="col-md-8">{selected?.status}</div>
            </div>
            {/* Created At */}
            <div className="row">
              <div className="col-md-4">Created At</div>
              <div className="col-md-8">
                {new Date(selected?.createdAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6  ">
          <div className="bg-white px-2 custom-border-radius-sm py-1">
            <QuoteQuickViewProducts selected={selected} />
          </div>
        </div>
      </div>
    </div>
  );
}
